import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeather2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFeather2"><Path d="M20.2363 4.46289C19.081 6.67523 17.4827 9.13311 14.6172 9.81445C15.2089 11.3494 14.9404 12.9423 14.0801 14.2285C12.974 15.882 10.9261 17 8.59668 17C7.3497 17 6.49342 17.3823 5.93945 17.9844C5.37448 18.5985 5 19.5762 5 21H3V16C3 8.8203 8.8203 3 16 3H21L20.2363 4.46289Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFeather2;
